// extracted by mini-css-extract-plugin
export default {"section":"Information_section__YvdqI","sider":"Information_sider__KzSiK","links":"Information_links__C9i2i","content":"Information_content__09ZbL"};